import type {Store} from 'redux';
import {qsArrayTransform} from '~/CreateGreetingCard/utils/navigation';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';

export const getLastPathComponent = (path: string) => {
  const components = path.split('/');
  return components[components.length - 1];
};

const getGalleryUrl = (force = false) => {
  const urlParams = new URLSearchParams(window.location.search);

  const category = urlParams.get('c');
  const page = urlParams.get('page');
  const filter = qsArrayTransform('filter');

  if (!force && (!category || !page)) {
    return '/';
  }
  return category && page ? `/gallery/category/${category}/${page}?${filter}` : '/gallery';
};

export const backToGallery = (force = false) => {
  window.location.href = getGalleryUrl(force);
};

export const setInEditMode = async (store: Store) => {
  store.dispatch({
    type: UPDATE_EVENT_DETAILS,
    payload: {inEditMode: true},
  });
  return true; // allow navigation
};
